<template>
  <div>
    <div class="d-block">
      <div class="card-body ma-0 pa-0">
        <div class="bg-danger text-white">
          <div class="d-flex text-lg py-1 px-1 border-top">
            <div class="w-50 border-right">
              <div class="text-center text-lg text-monospace">
                ยอดแทงรวม
              </div>
            </div>
            <div class="w-50">
              <div class="text-center text-lg text-monospace">
                ยอดถูกรวม
              </div>
            </div>
          </div>
        </div>

        <div class="text-white">
          <div class="d-flex text-lg py-1 px-1 border-top">
            <div class="w-50 border-right">
              <div class="text-center text-lg text-monospace text-success">
                {{
                  Intl.NumberFormat("en-US").format(
                    transaction.ticketNumber.reduce((sum, number) => {
                      return sum + number.amount;
                    }, 0)
                  )
                }}
              </div>
            </div>
            <div class="w-50">
              <div class="text-center text-lg text-monospace text-danger">
                {{
                  Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(
                    transaction.ticketNumber.reduce((sum, number) => {
                      return sum + number.win_amount;
                    }, 0)
                  )
                }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="(constant, slug_name) in transaction.constants"
          :key="slug_name"
        >
          <div
            v-if="
              transaction.ticketNumber.filter(
                (number) => number.slug == slug_name
              ).length > 0
            "
          >
            <h1 class="text-xl bg-yellow text-black text-left py-2 px-2 mb-0">
              {{ constant }}
            </h1>
            <div
              class="
                d-flex
                text-md
                font-weight-bold
                py-1
                border-top
                bg-black
                text-white
              "
            >
              <div class="w-20x text-center border-right">
                <div class="text-monospace">
                  แทง
                </div>
              </div>
              <div
                class="text-center border-right"
                style="width: 16%"
              >
                <div class="text-monospace">
                  รางวัล
                </div>
              </div>
              <div
                class="text-center border-right"
                style="width: 18%"
              >
                <div class="text-monospace">
                  ยอดแทง
                </div>
              </div>
              <div class="w-20x text-center border-right">
                <div class="text-monospace">
                  จ่าย
                </div>
              </div>
              <div
                class="text-center"
                style="width: 26%"
              >
                <div class="text-monospace">
                  ยอดถูก
                </div>
              </div>
            </div>
            <div
              v-for="(item, index) in transaction.ticketNumber.filter(
                (number) => number.slug == slug_name
              )"
              :key="index"
              :class="changeColor(item.win_amount)"
            >
              <div class="d-flex text-lg py-1 border-top">
                <div class="w-20x border-right">
                  <div class="text-center text-md">
                    {{ item.digits }}
                    <span v-if="slug_name != '4upper'">
                      <i :class="iconType(slug_name)" />
                    </span>
                  </div>
                </div>
                <div
                  class="border-right"
                  style="width: 16%"
                >
                  <div class="text-center text-md">
                    {{ item.result ? item.result : "-" }}
                  </div>
                </div>
                <div
                  class="border-right"
                  style="width: 18%"
                >
                  <div class="text-center text-md">
                    {{ Intl.NumberFormat("en-US").format(item.amount) }}
                  </div>
                </div>
                <div class="w-20x border-right">
                  <div class="text-center text-md">
                    {{ Intl.NumberFormat("en-US").format(item.prize_rate) }}
                  </div>
                </div>
                <div style="width: 26%">
                  <div class="text-center text-md">
                    {{
                      Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(item.win_amount > 0 ? item.win_amount : 0)
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TicketNumberTable',
  props: {
    transaction: { default: null },
  },
  data: () => ({
    items: [],
    loading: true,
    options: {},
    headers: [],
    slugName: '',
    sumAmountAll: 0,
  }),
  computed: {
    getSumamount() {
      this.transaction.ticketNumber.reduce((sum, number) => sum + number.amount, 0);
    },
  },
  watch: {},
  methods: {
    changeColor(data) {
      if (data > 0) {
        return 'text-success bg-win-yellow';
      }
    },
    iconType(slug) {
      switch (slug) {
        case '4upper':
          return '';
          break;
        case '3upper':
          return 'fas fa-arrow-up';
          break;
        case '3shuffle':
          return 'fas fa-sync-alt';
          break;
        case '3front':
          return 'fas fa-arrow-left';
          break;
        case '3back':
          return 'fas fa-arrow-right';
          break;
        case '2upper':
          return 'fas fa-arrow-up';
          break;
        case '2under':
          return 'fas fa-arrow-down';
          break;
        case 'any_upper':
          return 'fas fa-arrow-up';
          break;
      }
    },
  },
};
</script>
